import moment from 'moment';
export default {install (Vue)
    {
      const fechas = {

          fechaInicioPeAutorizacion(date){
            return  moment(date).add(1, 'days').format('YYYY-MM-DD');;
          },
          fechaFinPeAutorizacion(date){
            return  moment(date).format('YYYY-MM-DD');;
          },
          fechaFinDesdePE(date){
            let dates =  moment(date).add(1, 'days').format('YYYY-MM-DD');
            return dates;
          },
          fechaFinHastaPE(date){
            let dates =  moment(date).add(90, 'days').format('YYYY-MM-DD');
            return dates;
          },
          ObtenerFechaActual () {
            return  moment(new Date()).format('DD/MM/YYYY');
          },
          ObtenerFechaActualParaRest () {
            return  moment(new Date()).format('YYYY-MM-DD');
          },
          ObtenerFechaActualSinFormato () {
            return moment().format();
          },
          ObtenerGestionActual() {
            return moment().format('YYYY');
          },
          ObtenerMesActual() {
            return moment().format('MM');
          },
          FormatearFecha (pFecha) {
            if (pFecha != null && pFecha != '')
              return moment(pFecha,'YYYY-MM-DDTHH:mm:ssZ').format('DD/MM/YYYY HH:mm');
            return ''
          },
          FormatearFechaParaRest (pFecha) {

            if (pFecha != null && pFecha != '')
              return moment(pFecha,'DD/MM/YYYY HH:mm').format('YYYY-MM-DDTHH:mm:ssZ');
            return ''
          },
          FormatearDDMMYYYY_to_YYYYMMDDTHHmmssZ (pFecha) {

            if (pFecha != null && pFecha != '')
            {

              return moment(pFecha,'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ssZ');
            }

            return ''
          },
          FormatearYYYYMMDDTHHmmssZ_to_DDMMYYYY (pFecha) {
            if (pFecha != null && pFecha != ''){
              return moment(pFecha,'YYYY-MM-DDTHH:mm:ssZ').format('DD/MM/YYYY');
            }
            return ''
          },
          esFechaCorrectaDDMMYYYY(fecha)
          {
            if (moment(fecha,['DD/MM/YYYY']).isValid()) {
              return true;
            } else {
              return false;
            }
          },

          FormatearFechaSinHoras (pFecha) {
            if (pFecha != null && pFecha != '')
              return moment(pFecha,'YYYY-MM-DDTHH:mm:ssZ').format('DD/MM/YYYY');
            return ''
          },
          FormatearFechaSinHorasLocal (pFecha) {
            if (pFecha != null && pFecha != '' && pFecha != '1900-01-01T00:00:00.000+0000')
              return moment(pFecha,moment.HTML5_FMT.DATETIME_LOCAL_MS).format('DD/MM/YYYY');
            return ''
          },
          FormatearFechaConHorasLocal (pFecha) {
            if (pFecha != null && pFecha != '' && pFecha != '1900-01-01T00:00:00.000+0000')
              return moment(pFecha,moment.HTML5_FMT.DATETIME_LOCAL_MS).format('DD/MM/YYYY HH:mm');
            return ''
          },
          ObtenerHoraDeFecha(pFecha){
            if (pFecha != null && pFecha != '')
              return moment(pFecha,'YYYY-MM-DDTHH:mm:ssZ').format('hh:mm:ss a');
            return ''
          },
          DiferenciaFechas (pFechaIni, pFechaFin) {
            let vDias = 0;
            let vFechaIni = moment(pFechaIni, 'YYYY-MM-DD');
            let vFechaFin = moment(pFechaFin, 'YYYY-MM-DD');

            if (vFechaFin > vFechaIni)
              vDias = vFechaFin.diff(vFechaIni, 'days');

            return vDias;
          },
        }
        Vue.prototype.$fechas = fechas;
      }
    }
